import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";

import { useStyles } from "./FileUpload.styles";

const FileUpload = ({ initialText, btnLabel, afterUpload, disabled }) => {
  const classes = useStyles();
  const [file, setFile] = useState({ data: null, isFileUploaded: false });

  const recievedFile = (event) => {
    let formData = new FormData();
    let name = event.target.files[0].name;
    formData.append("file", event.target.files[0], name);
    setFile({ data: formData, name, isFileUploaded: true });
  };

  useEffect(() => {
    if (file.isFileUploaded) {
      afterUpload(file);
    }
  }, [file]);

  return (
    <>
      <div className={classes.fileUploadWrapper} data-testid="file-upload">
        {!file.isFileUploaded && (
          <span className={[classes.initialText, classes.ellipsis].join(" ")}>
            {initialText}
          </span>
        )}
        {file.isFileUploaded && (
          <span
            className={[classes.initialText, classes.uploadedText].join(" ")}
          >
            <CheckCircle />
            <span className={classes.ellipsis} data-uploadedtest="uploadedText">
              {file.name}
            </span>
          </span>
        )}
        <div className={classes.fileUploadWrap} data-droptestid="dropzone">
          <input
            type="file"
            id="fileUpload"
            name="fileUpload"
            className={`${classes.fileUpload} ${
              disabled ? classes.disabled : ""
            }`}
            onChange={recievedFile}
            disabled={disabled}
          />
          <Button
            variant="outlined"
            disabled={disabled}
            color="primary"
            className={classes.upload}
          >
            {btnLabel}
          </Button>
        </div>
      </div>
    </>
  );
};

FileUpload.propTypes = {
  initialText: PropTypes.string,
  btnLabel: PropTypes.string,
  afterUpload: PropTypes.func,
  disabled: PropTypes.bool,
};

export { FileUpload };
